import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from '../layouts/error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_2cd249f0 from 'nuxt_plugin_plugin_2cd249f0' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_nuxtgooglemaps_6431c3f9 from 'nuxt_plugin_nuxtgooglemaps_6431c3f9' // Source: ./nuxt-google-maps.js (mode: 'all')
import nuxt_plugin_recaptcha_071da18d from 'nuxt_plugin_recaptcha_071da18d' // Source: ./recaptcha.js (mode: 'all')
import nuxt_plugin_googlegtag_9fa71b66 from 'nuxt_plugin_googlegtag_9fa71b66' // Source: ./google-gtag.js (mode: 'client')
import nuxt_plugin_metaplugin_e45ab666 from 'nuxt_plugin_metaplugin_e45ab666' // Source: ./pwa/meta.plugin.js (mode: 'all')
import nuxt_plugin_iconplugin_db0b6b7e from 'nuxt_plugin_iconplugin_db0b6b7e' // Source: ./pwa/icon.plugin.js (mode: 'all')
import nuxt_plugin_vuescrollto_beba93aa from 'nuxt_plugin_vuescrollto_beba93aa' // Source: ./vue-scrollto.js (mode: 'client')
import nuxt_plugin_nuxtmq_523c43a6 from 'nuxt_plugin_nuxtmq_523c43a6' // Source: ./nuxt-mq.js (mode: 'all')
import nuxt_plugin_nuxtuseragent_536d2f67 from 'nuxt_plugin_nuxtuseragent_536d2f67' // Source: ./nuxt-user-agent.js (mode: 'all')
import nuxt_plugin_cookieuniversalnuxt_2420f5c6 from 'nuxt_plugin_cookieuniversalnuxt_2420f5c6' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_pluginrouting_36fa3430 from 'nuxt_plugin_pluginrouting_36fa3430' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_7dda0e87 from 'nuxt_plugin_pluginmain_7dda0e87' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_gtm_0b23ef18 from 'nuxt_plugin_gtm_0b23ef18' // Source: ./gtm.js (mode: 'all')
import nuxt_plugin_axios_7823521e from 'nuxt_plugin_axios_7823521e' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_filters_2dd71012 from 'nuxt_plugin_filters_2dd71012' // Source: ../plugins/filters.js (mode: 'all')
import nuxt_plugin_sharedelements_3ed40ba4 from 'nuxt_plugin_sharedelements_3ed40ba4' // Source: ../plugins/shared-elements.js (mode: 'all')
import nuxt_plugin_i18n_1fba523a from 'nuxt_plugin_i18n_1fba523a' // Source: ../plugins/i18n.js (mode: 'all')
import nuxt_plugin_axios_5659d192 from 'nuxt_plugin_axios_5659d192' // Source: ../plugins/axios.js (mode: 'all')
import nuxt_plugin_vuega_72bdd120 from 'nuxt_plugin_vuega_72bdd120' // Source: ../plugins/vue-ga.js (mode: 'all')
import nuxt_plugin_directives_521c0486 from 'nuxt_plugin_directives_521c0486' // Source: ../plugins/directives.js (mode: 'client')
import nuxt_plugin_liveChat_b3426846 from 'nuxt_plugin_liveChat_b3426846' // Source: ../plugins/liveChat.js (mode: 'client')
import nuxt_plugin_vuelazyload_d07c1d40 from 'nuxt_plugin_vuelazyload_d07c1d40' // Source: ../plugins/vue-lazyload.js (mode: 'all')
import nuxt_plugin_popups_4b24a49a from 'nuxt_plugin_popups_4b24a49a' // Source: ../plugins/popups.js (mode: 'client')
import nuxt_plugin_vuexroutersync_9c8d1186 from 'nuxt_plugin_vuexroutersync_9c8d1186' // Source: ../plugins/vuex-router-sync.js (mode: 'all')
import nuxt_plugin_router_79dc5b58 from 'nuxt_plugin_router_79dc5b58' // Source: ../plugins/router.js (mode: 'client')
import nuxt_plugin_vuelidate_4be431c8 from 'nuxt_plugin_vuelidate_4be431c8' // Source: ../plugins/vuelidate.js (mode: 'client')
import nuxt_plugin_vueobservevisibility_66676af7 from 'nuxt_plugin_vueobservevisibility_66676af7' // Source: ../plugins/vue-observe-visibility.js (mode: 'client')
import nuxt_plugin_vueloadingskeleton_2413947c from 'nuxt_plugin_vueloadingskeleton_2413947c' // Source: ../plugins/vue-loading-skeleton.js (mode: 'all')
import nuxt_plugin_facebookevents_7f903ded from 'nuxt_plugin_facebookevents_7f903ded' // Source: ../plugins/facebook-events.js (mode: 'client')
import nuxt_plugin_gtm_5e4639ea from 'nuxt_plugin_gtm_5e4639ea' // Source: ../plugins/gtm (mode: 'client')
import nuxt_plugin_vuetouch_737c6982 from 'nuxt_plugin_vuetouch_737c6982' // Source: ../plugins/vue-touch (mode: 'client')
import nuxt_plugin_affiliates_01dae4bc from 'nuxt_plugin_affiliates_01dae4bc' // Source: ../plugins/affiliates (mode: 'client')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root.$options.$nuxt
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext, config)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"adidas","titleTemplate":"%s","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":""},{"name":"google-site-verification","content":"PThv_TKA_zNqxZjUVZ6JfWra1BWWjV8LjWlm7C0jVHg"},{"property":"og:image","content":"https:\u002F\u002Fwww.adidas.ua\u002Fog-image.jpg","hid":"og:image"}],"link":[{"rel":"icon","type":"image\u002Fpng","href":"\u002Ffavicon.png"},{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico?1=1"},{"rel":"shortcut icon","href":"\u002Ffavicon.ico?1=1"},{"rel":"apple-touch-icon","size":"180x180","href":"\u002Fapple-touch-icon.png?1=1"},{"rel":"icon","type":"image\u002Fpng","size":"32x32","href":"\u002Ffavicon-32x32.png?1=1"},{"rel":"icon","type":"image\u002Fpng","size":"16x16","href":"\u002Ffavicon-16x16.png?1=1"},{"rel":"manifest","href":"\u002Fsite.webmanifest?1=1","crossorigin":"use-credentials"},{"rel":"mask-icon","href":"\u002Fsafari-pinned-tab.svg?1=1","color":"rgba(0,0,0,1)"}],"script":[{"innerHTML":"(function(i,s,o,g,r,a,m){\n                \ti[\"esSdk\"] = r;\n                \ti[r] = i[r] || function() {\n                \t\t(i[r].q = i[r].q || []).push(arguments)\n                \t}, a=s.createElement(o), m=s.getElementsByTagName(o)[0]; a.async=1; a.src=g;\n                \tm.parentNode.insertBefore(a,m)}\n                \t) (window, document, \"script\", \"https:\u002F\u002Fesputnik.com\u002Fscripts\u002Fv1\u002Fpublic\u002Fscripts?apiKey=eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiI0NTI0ZWZhYTJkYzI2MGRmYTM4YTE1NDBlMWI1ZjE0ZWQ2YjkzZDEwMjQ0NWZhODcwNmFmNGY3MmRjOGE0ZjAyMzRhNGJkM2I0M2JhZWY2YzYxMDM3N2U2ZDgzYmRkMGIwOWNmZTUxMTU5Mzc3ZWJlYjczNDVjODMyNTFlZWEwMmQ4OWViZDNlMzI3MjY1NTZhNDdkYTI2MmViZGMxNjAyMGQ4YWUyOTY5ZjEzNjA1ZGYwMGJhZDk3OTRhYWNmIn0.ZuBr2RYZ60WrKUhmdjbgYZPKfTjSQBONu143kaR5xT7EnrX2JehPfhhOrASYV5XNajxh340mpUvAGinEin6Ngw&domain=40444FD9-2C00-4727-8AED-CDFFF94A1529\", \"es\");\n                \tes(\"pushOn\");"},{"innerHTML":"\n                !function (t, e, c, n) {\n                    var s = e.createElement(c);\n                    s.async = 1, s.src = 'https:\u002F\u002Fstatics.esputnik.com\u002Fscripts\u002F' + n + '.js';\n                    var r = e.scripts[0];\n                    r.parentNode.insertBefore(s, r);\n                    var f = function () {\n                        f.c(arguments);\n                    };\n                    f.q = [];\n                    f.c = function () {\n                        f.q.push(arguments);\n                    };\n                    t['eS'] = t['eS'] || f;\n                }(window, document, 'script', '08456167431441C69D34FC9E9AD2C7DD');","body":true,"async":true},{"src":"https:\u002F\u002Faccounts.google.com\u002Fgsi\u002Fclient","async":true,"defer":true},{"hid":"gtm-script","innerHTML":"if(!window._gtm_init){window._gtm_init=1;(function(w,n,d,m,e,p){w[d]=(w[d]==1||n[d]=='yes'||n[d]==1||n[m]==1||(w[e]&&w[e][p]&&w[e][p]()))?1:0})(window,navigator,'doNotTrack','msDoNotTrack','external','msTrackingProtectionEnabled');(function(w,d,s,l,x,y){w[x]={};w._gtm_inject=function(i){if(w.doNotTrack||w[x][i])return;w[x][i]=1;w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s);j.async=true;j.src='https:\u002F\u002Fwww.googletagmanager.com\u002Fgtm.js?id='+i;f.parentNode.insertBefore(j,f);};w[y]('GTM-N9F9M2Q')})(window,document,'script','dataLayer','_gtm_ids','_gtm_inject')}"},{"src":"https:\u002F\u002Fwww.googletagmanager.com\u002Fgtag\u002Fjs?id=AW-369411020","async":true}],"__dangerouslyDisableSanitizers":["script","innerHTML"],"style":[],"noscript":[{"hid":"gtm-noscript","pbody":true,"innerHTML":"\u003Ciframe src=\"https:\u002F\u002Fwww.googletagmanager.com\u002Fns.html?id=GTM-N9F9M2Q&\" height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" title=\"gtm\"\u003E\u003C\u002Fiframe\u003E"}],"__dangerouslyDisableSanitizersByTagID":{"gtm-script":["innerHTML"],"gtm-noscript":["innerHTML"]}},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_2cd249f0 === 'function') {
    await nuxt_plugin_plugin_2cd249f0(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtgooglemaps_6431c3f9 === 'function') {
    await nuxt_plugin_nuxtgooglemaps_6431c3f9(app.context, inject)
  }

  if (typeof nuxt_plugin_recaptcha_071da18d === 'function') {
    await nuxt_plugin_recaptcha_071da18d(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_googlegtag_9fa71b66 === 'function') {
    await nuxt_plugin_googlegtag_9fa71b66(app.context, inject)
  }

  if (typeof nuxt_plugin_metaplugin_e45ab666 === 'function') {
    await nuxt_plugin_metaplugin_e45ab666(app.context, inject)
  }

  if (typeof nuxt_plugin_iconplugin_db0b6b7e === 'function') {
    await nuxt_plugin_iconplugin_db0b6b7e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuescrollto_beba93aa === 'function') {
    await nuxt_plugin_vuescrollto_beba93aa(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtmq_523c43a6 === 'function') {
    await nuxt_plugin_nuxtmq_523c43a6(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtuseragent_536d2f67 === 'function') {
    await nuxt_plugin_nuxtuseragent_536d2f67(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_2420f5c6 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_2420f5c6(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_36fa3430 === 'function') {
    await nuxt_plugin_pluginrouting_36fa3430(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_7dda0e87 === 'function') {
    await nuxt_plugin_pluginmain_7dda0e87(app.context, inject)
  }

  if (typeof nuxt_plugin_gtm_0b23ef18 === 'function') {
    await nuxt_plugin_gtm_0b23ef18(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_7823521e === 'function') {
    await nuxt_plugin_axios_7823521e(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_2dd71012 === 'function') {
    await nuxt_plugin_filters_2dd71012(app.context, inject)
  }

  if (typeof nuxt_plugin_sharedelements_3ed40ba4 === 'function') {
    await nuxt_plugin_sharedelements_3ed40ba4(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_1fba523a === 'function') {
    await nuxt_plugin_i18n_1fba523a(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_5659d192 === 'function') {
    await nuxt_plugin_axios_5659d192(app.context, inject)
  }

  if (typeof nuxt_plugin_vuega_72bdd120 === 'function') {
    await nuxt_plugin_vuega_72bdd120(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_directives_521c0486 === 'function') {
    await nuxt_plugin_directives_521c0486(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_liveChat_b3426846 === 'function') {
    await nuxt_plugin_liveChat_b3426846(app.context, inject)
  }

  if (typeof nuxt_plugin_vuelazyload_d07c1d40 === 'function') {
    await nuxt_plugin_vuelazyload_d07c1d40(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_popups_4b24a49a === 'function') {
    await nuxt_plugin_popups_4b24a49a(app.context, inject)
  }

  if (typeof nuxt_plugin_vuexroutersync_9c8d1186 === 'function') {
    await nuxt_plugin_vuexroutersync_9c8d1186(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_router_79dc5b58 === 'function') {
    await nuxt_plugin_router_79dc5b58(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuelidate_4be431c8 === 'function') {
    await nuxt_plugin_vuelidate_4be431c8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueobservevisibility_66676af7 === 'function') {
    await nuxt_plugin_vueobservevisibility_66676af7(app.context, inject)
  }

  if (typeof nuxt_plugin_vueloadingskeleton_2413947c === 'function') {
    await nuxt_plugin_vueloadingskeleton_2413947c(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_facebookevents_7f903ded === 'function') {
    await nuxt_plugin_facebookevents_7f903ded(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_gtm_5e4639ea === 'function') {
    await nuxt_plugin_gtm_5e4639ea(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetouch_737c6982 === 'function') {
    await nuxt_plugin_vuetouch_737c6982(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_affiliates_01dae4bc === 'function') {
    await nuxt_plugin_affiliates_01dae4bc(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
